import { Query, Mutation } from "react-apollo";
import React from "react";
import gql from "graphql-tag";
import UserForm from "../../components/UserForm/";

class NewUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        name: "",
        email: "",
        organization: "",
        industry: null,
        roles: [],
        isActive: true,
        specialPermissions: {
          isAdmin: false,
          isPerformance: false,
        },
        isFreeTrial: false,
        freeTrialStartDate: "",
        freeTrialEndDate: "",
        error: "",
        disableDeviceCheck: false,
        deviceLimit: 2,
        excludeRespondents: false,
      },
    };
  }

  submitResponse = (data) => {
    let message = "";
    let payload = {};

    if (data && data.createUser && data.createUser.meta) {
      message = data.createUser.meta.message;
      payload = data.createUser.meta.payload;
    }

    if (data && message === "successfulSignUp") {
      let link = payload.host + "/reset-password?token=" + payload.token;
      this.props.history.push({ pathname: "/new-user/success", link });
    } else if (payload && payload.error) {
      alert(payload.error);
      this.setState({ error: payload.error });
    } else {
      this.setState({ error: "Error occurred while creating user." });
      alert("Error occurred while creating user.");
    }
  };

  render() {
    return (
      <div>
        <div className="page-header">
          <i className="fas fa-user-plus fa-lg"></i>
          <h3>Create New User</h3>
        </div>

        <div>
          <UserForm
            user={this.state.user}
            viewer={this.props.data.viewer}
            userRoles={this.props.data.userRoles}
            mutate={this.props.createUser}
            submitResponse={this.submitResponse}
          />
        </div>
      </div>
    );
  }
}

const CREATE_USER = gql`
  mutation CREATE_USER(
    $name: String!
    $email: String!
    $organization: String!
    $industry: Industry!
    $roles: [String!]
    $isActive: Boolean!
    $specialPermissions: specialPermissionsInput!
    $canStartTrial: Boolean!
    $requirePasswordReset: Boolean!
    $isFreeTrial: Boolean!
    $disableDeviceCheck: Boolean
    $sendActivationEmail: Boolean
    $freeTrialStartDate: String
    $freeTrialEndDate: String
    $deviceLimit: Int
    $excludeRespondents: Boolean!
  ) {
    createUser(
      name: $name
      email: $email
      organization: $organization
      industry: $industry
      roles: $roles
      isActive: $isActive
      specialPermissions: $specialPermissions
      canStartTrial: $canStartTrial
      requirePasswordReset: $requirePasswordReset
      isFreeTrial: $isFreeTrial
      freeTrialStartDate: $freeTrialStartDate
      freeTrialEndDate: $freeTrialEndDate
      disableDeviceCheck: $disableDeviceCheck
      sendActivationEmail: $sendActivationEmail
      deviceLimit: $deviceLimit
      excludeRespondents: $excludeRespondents
    ) {
      meta {
        payload
        message
      }
    }
  }
`;

const GET_VIEWER_AND_ROLES = gql`
  query GET_VIEWER_AND_ROLES {
    viewer {
      id
      roles
      editableRoles
      specialPermissions {
        isAdmin
      }
    }
    userRoles {
      name
      description
      group
      displayName
    }
  }
`;

const CreateUserWithData = (props) => (
  <Query query={GET_VIEWER_AND_ROLES} fetchPolicy="network-only">
    {({ loading, error, data }) => {
      let noData = !data || !data.user || !data.roles || !data.dashboardRoutes;

      if (loading && noData) return <div>Loading...</div>;

      if (error) return <div>Error: {error}</div>;

      return (
        <Mutation mutation={CREATE_USER}>
          {(createUser) => {
            return <NewUser createUser={createUser} {...props} data={data} />;
          }}
        </Mutation>
      );
    }}
  </Query>
);

export default CreateUserWithData;
